"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContainer = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const modalOverlayStyling = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    backgroundColor: '#000',
    opacity: '.35'
};
const modalWrapperStyles = {
    display: 'block !important',
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    margin: '0 15px',
    height: '100%',
    outline: '0',
    overflowX: 'hidden',
    overflowY: 'auto'
};
const ModalContainer = ({ modals, close, wrapperIndex }) => {
    const wrapperIndexUsed = wrapperIndex || '1041';
    const handleClick = () => {
        const top = modals[modals.length - 1];
        if (top.closeOnExternalClick) {
            close();
        }
    };
    const generated = modals.map((m, index) => {
        return (react_1.default.createElement(react_1.default.Fragment, { key: index }, m.modal));
    });
    return modals.length > 0 ? react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "modal-backdrop fade show" }),
        react_1.default.createElement("div", { onClick: handleClick, style: Object.assign(Object.assign({}, modalWrapperStyles), { zIndex: wrapperIndexUsed }) }, generated)), document.body) : null;
};
exports.ModalContainer = ModalContainer;
